var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubblesMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 639,
    viewBox: "0 0 428 639",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_41704)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_305_41704)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M219.432 448.831C218.951 448.275 218.317 447.877 217.612 447.686C216.907 447.496 216.163 447.522 215.473 447.761C214.782 448 214.177 448.442 213.734 449.03C213.291 449.618 213.03 450.326 212.984 451.065C212.938 451.803 213.108 452.539 213.474 453.179C213.84 453.82 214.385 454.335 215.04 454.661C215.695 454.987 216.43 455.109 217.153 455.01C217.876 454.912 218.554 454.599 219.102 454.109C219.835 453.454 220.282 452.529 220.344 451.54C220.406 450.55 220.078 449.575 219.432 448.831Z",
    fill: "url(#paint0_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M229.78 453.355C229.492 453.023 229.113 452.785 228.692 452.672C228.271 452.559 227.826 452.574 227.414 452.718C227.001 452.861 226.64 453.125 226.376 453.476C226.111 453.827 225.956 454.251 225.928 454.692C225.901 455.133 226.003 455.573 226.222 455.955C226.441 456.337 226.766 456.645 227.158 456.84C227.549 457.034 227.988 457.107 228.42 457.048C228.852 456.989 229.257 456.801 229.584 456.509C229.801 456.315 229.979 456.08 230.106 455.816C230.234 455.553 230.309 455.266 230.327 454.973C230.345 454.68 230.306 454.386 230.212 454.109C230.118 453.831 229.971 453.575 229.78 453.355Z",
    fill: "url(#paint1_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M224.198 457.802C224.013 457.587 223.77 457.433 223.499 457.359C223.227 457.285 222.94 457.294 222.674 457.385C222.408 457.476 222.175 457.646 222.004 457.872C221.832 458.098 221.731 458.371 221.713 458.655C221.695 458.94 221.76 459.223 221.901 459.47C222.041 459.717 222.251 459.916 222.503 460.042C222.755 460.167 223.039 460.214 223.317 460.177C223.596 460.139 223.857 460.018 224.068 459.83C224.348 459.577 224.519 459.223 224.544 458.843C224.568 458.463 224.444 458.089 224.198 457.802Z",
    fill: "url(#paint2_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M255.879 449.233C255.694 449.018 255.45 448.865 255.178 448.791C254.907 448.717 254.62 448.727 254.354 448.819C254.088 448.911 253.855 449.081 253.684 449.308C253.514 449.534 253.413 449.807 253.395 450.091C253.378 450.376 253.444 450.659 253.585 450.906C253.726 451.152 253.936 451.351 254.189 451.476C254.441 451.601 254.724 451.648 255.003 451.609C255.281 451.571 255.542 451.449 255.753 451.26C255.892 451.136 256.006 450.984 256.088 450.815C256.17 450.646 256.218 450.461 256.23 450.273C256.242 450.085 256.217 449.896 256.157 449.718C256.096 449.539 256.002 449.374 255.879 449.233Z",
    fill: "url(#paint3_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M214.712 468.188C214.678 468.134 214.633 468.089 214.58 468.054C214.527 468.02 214.467 467.998 214.405 467.989C214.343 467.98 214.28 467.985 214.22 468.004C214.159 468.022 214.104 468.054 214.057 468.096C214.01 468.138 213.972 468.19 213.947 468.248C213.922 468.307 213.909 468.37 213.91 468.434C213.911 468.497 213.926 468.56 213.953 468.618C213.98 468.675 214.019 468.726 214.067 468.766C214.143 468.852 214.249 468.903 214.362 468.911C214.475 468.918 214.586 468.881 214.673 468.806C214.758 468.729 214.81 468.621 214.817 468.505C214.824 468.389 214.787 468.276 214.712 468.188Z",
    fill: "url(#paint4_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M232.584 466.147C232.508 466.061 232.401 466.008 232.287 466.001C232.173 465.993 232.061 466.032 231.974 466.108C231.89 466.185 231.839 466.292 231.832 466.407C231.825 466.521 231.862 466.634 231.935 466.722C232.011 466.808 232.118 466.861 232.232 466.868C232.346 466.876 232.458 466.837 232.545 466.761C232.628 466.684 232.68 466.577 232.687 466.463C232.694 466.348 232.657 466.235 232.584 466.147Z",
    fill: "url(#paint5_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M266.623 461.614C266.566 461.548 266.492 461.5 266.408 461.477C266.325 461.454 266.237 461.457 266.155 461.484C266.073 461.512 266.001 461.564 265.949 461.634C265.896 461.704 265.865 461.787 265.859 461.875C265.854 461.962 265.874 462.05 265.917 462.125C265.961 462.201 266.026 462.262 266.103 462.3C266.181 462.339 266.268 462.353 266.354 462.341C266.439 462.329 266.519 462.291 266.584 462.233C266.669 462.155 266.721 462.047 266.728 461.932C266.736 461.816 266.698 461.702 266.623 461.614Z",
    fill: "url(#paint6_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M261.108 465.427C261.032 465.341 260.925 465.288 260.811 465.281C260.697 465.273 260.585 465.312 260.499 465.387C260.415 465.465 260.364 465.572 260.356 465.686C260.349 465.801 260.386 465.914 260.459 466.001C260.536 466.088 260.642 466.141 260.756 466.148C260.87 466.155 260.983 466.117 261.069 466.041C261.153 465.964 261.204 465.857 261.211 465.742C261.219 465.628 261.182 465.515 261.108 465.427Z",
    fill: "url(#paint7_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M234.582 479.443C233.898 478.661 233 478.101 232.002 477.835C231.004 477.569 229.951 477.608 228.976 477.949C228 478.289 227.146 478.915 226.52 479.747C225.895 480.579 225.526 481.581 225.461 482.625C225.395 483.67 225.636 484.711 226.153 485.617C226.67 486.523 227.439 487.253 228.364 487.716C229.29 488.179 230.329 488.353 231.352 488.218C232.375 488.082 233.335 487.642 234.112 486.953C234.631 486.493 235.055 485.933 235.36 485.305C235.665 484.678 235.844 483.996 235.888 483.298C235.932 482.6 235.839 481.9 235.615 481.238C235.391 480.577 235.04 479.967 234.582 479.443Z",
    fill: "url(#paint8_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M245.316 460.599C244.975 460.204 244.527 459.92 244.027 459.785C243.527 459.649 242.999 459.667 242.509 459.836C242.019 460.005 241.59 460.318 241.276 460.735C240.962 461.152 240.777 461.655 240.744 462.179C240.712 462.703 240.834 463.225 241.094 463.678C241.354 464.132 241.741 464.497 242.206 464.727C242.671 464.957 243.193 465.042 243.706 464.971C244.218 464.899 244.699 464.675 245.086 464.327C245.601 463.862 245.915 463.209 245.958 462.511C246.002 461.812 245.771 461.125 245.316 460.599Z",
    fill: "url(#paint9_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M201.784 478.383C201.444 477.988 200.995 477.704 200.496 477.568C199.996 477.431 199.468 477.448 198.978 477.617C198.488 477.786 198.058 478.098 197.744 478.515C197.429 478.932 197.243 479.434 197.21 479.958C197.177 480.482 197.298 481.004 197.558 481.458C197.818 481.912 198.205 482.277 198.669 482.508C199.134 482.739 199.656 482.824 200.169 482.753C200.681 482.683 201.162 482.459 201.549 482.111C202.065 481.647 202.38 480.995 202.424 480.296C202.468 479.598 202.238 478.91 201.784 478.383Z",
    fill: "url(#paint10_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M230.363 421.999C230.022 421.604 229.573 421.321 229.074 421.185C228.574 421.05 228.046 421.067 227.556 421.237C227.066 421.406 226.637 421.719 226.323 422.136C226.009 422.553 225.824 423.056 225.791 423.58C225.759 424.103 225.88 424.625 226.141 425.079C226.401 425.533 226.788 425.898 227.253 426.128C227.718 426.358 228.24 426.443 228.753 426.372C229.265 426.3 229.746 426.076 230.132 425.728C230.648 425.263 230.962 424.61 231.005 423.912C231.048 423.213 230.818 422.526 230.363 421.999Z",
    fill: "url(#paint11_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M184.218 439.607C183.877 439.212 183.428 438.929 182.928 438.793C182.428 438.658 181.9 438.675 181.41 438.845C180.921 439.014 180.492 439.327 180.177 439.744C179.863 440.161 179.678 440.664 179.646 441.187C179.613 441.711 179.735 442.233 179.995 442.687C180.256 443.141 180.643 443.506 181.108 443.736C181.573 443.966 182.095 444.051 182.607 443.98C183.12 443.908 183.6 443.684 183.987 443.336C184.503 442.871 184.816 442.218 184.86 441.52C184.903 440.821 184.672 440.134 184.218 439.607Z",
    fill: "url(#paint12_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.186 405.001C190.022 404.813 189.807 404.678 189.567 404.613C189.328 404.549 189.075 404.558 188.84 404.639C188.606 404.721 188.4 404.871 188.25 405.071C188.099 405.27 188.011 405.511 187.995 405.762C187.979 406.013 188.037 406.263 188.161 406.481C188.285 406.698 188.47 406.874 188.693 406.985C188.915 407.096 189.165 407.137 189.41 407.104C189.656 407.071 189.887 406.965 190.073 406.799C190.197 406.689 190.299 406.555 190.372 406.405C190.445 406.255 190.489 406.091 190.499 405.924C190.51 405.757 190.487 405.589 190.434 405.431C190.38 405.273 190.296 405.127 190.186 405.001Z",
    fill: "url(#paint13_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M266.032 472.76C265.833 472.53 265.571 472.365 265.28 472.286C264.989 472.207 264.681 472.218 264.396 472.316C264.111 472.415 263.861 472.597 263.677 472.84C263.494 473.082 263.386 473.375 263.366 473.68C263.347 473.985 263.417 474.289 263.568 474.554C263.719 474.819 263.944 475.032 264.214 475.167C264.484 475.302 264.788 475.353 265.087 475.313C265.386 475.273 265.666 475.143 265.892 474.942C266.043 474.808 266.166 474.645 266.254 474.463C266.342 474.281 266.395 474.083 266.407 473.88C266.42 473.677 266.394 473.474 266.329 473.282C266.265 473.09 266.164 472.912 266.032 472.76Z",
    fill: "url(#paint14_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.74 474.355C222.539 474.129 222.277 473.969 221.986 473.894C221.696 473.819 221.39 473.833 221.107 473.933C220.824 474.034 220.577 474.217 220.396 474.459C220.215 474.702 220.108 474.993 220.09 475.297C220.071 475.6 220.141 475.903 220.291 476.166C220.441 476.429 220.665 476.642 220.933 476.777C221.202 476.912 221.504 476.964 221.801 476.926C222.098 476.888 222.378 476.762 222.605 476.564C222.759 476.429 222.885 476.264 222.975 476.08C223.066 475.895 223.119 475.694 223.131 475.488C223.144 475.282 223.116 475.076 223.049 474.881C222.982 474.687 222.877 474.508 222.74 474.355Z",
    fill: "url(#paint15_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M249.954 484.002C249.813 483.84 249.629 483.723 249.423 483.668C249.217 483.612 249 483.62 248.799 483.689C248.597 483.759 248.421 483.888 248.291 484.059C248.162 484.231 248.086 484.438 248.072 484.653C248.059 484.869 248.109 485.083 248.216 485.27C248.323 485.457 248.482 485.607 248.673 485.702C248.864 485.797 249.079 485.832 249.29 485.803C249.501 485.774 249.698 485.682 249.858 485.539C250.071 485.348 250.201 485.079 250.219 484.791C250.237 484.503 250.141 484.219 249.954 484.002Z",
    fill: "url(#paint16_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M255.329 452.365C255.189 452.204 255.004 452.088 254.798 452.033C254.593 451.978 254.376 451.986 254.175 452.056C253.974 452.126 253.798 452.254 253.669 452.426C253.54 452.597 253.464 452.804 253.45 453.019C253.437 453.234 253.487 453.449 253.593 453.635C253.7 453.822 253.859 453.972 254.05 454.067C254.241 454.162 254.455 454.198 254.666 454.169C254.876 454.141 255.074 454.049 255.234 453.907C255.447 453.715 255.577 453.445 255.595 453.156C255.613 452.867 255.517 452.583 255.329 452.365Z",
    fill: "url(#paint17_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.847 477.287C251.501 476.889 251.046 476.604 250.54 476.469C250.034 476.333 249.5 476.352 249.005 476.525C248.51 476.697 248.076 477.014 247.759 477.436C247.442 477.859 247.255 478.367 247.222 478.897C247.189 479.427 247.312 479.955 247.575 480.414C247.837 480.873 248.228 481.243 248.698 481.477C249.168 481.71 249.696 481.798 250.214 481.727C250.733 481.657 251.219 481.432 251.612 481.082C251.874 480.848 252.087 480.565 252.24 480.248C252.393 479.931 252.484 479.586 252.505 479.234C252.527 478.881 252.48 478.528 252.367 478.194C252.255 477.86 252.078 477.552 251.847 477.287Z",
    fill: "url(#paint18_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M214.842 400.959C214.359 400.406 213.725 400.011 213.021 399.824C212.317 399.636 211.574 399.664 210.885 399.905C210.197 400.145 209.594 400.587 209.152 401.174C208.711 401.762 208.451 402.469 208.405 403.206C208.359 403.944 208.529 404.678 208.894 405.318C209.259 405.957 209.802 406.472 210.455 406.799C211.108 407.125 211.842 407.249 212.564 407.153C213.286 407.057 213.963 406.746 214.512 406.26C214.877 405.934 215.176 405.539 215.391 405.096C215.606 404.653 215.732 404.172 215.763 403.679C215.794 403.186 215.728 402.693 215.57 402.226C215.412 401.759 215.165 401.328 214.842 400.959Z",
    fill: "url(#paint19_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M225.209 405.496C224.921 405.165 224.543 404.927 224.122 404.814C223.7 404.7 223.256 404.716 222.843 404.859C222.431 405.002 222.07 405.266 221.805 405.618C221.541 405.969 221.385 406.392 221.358 406.833C221.33 407.275 221.433 407.714 221.651 408.097C221.87 408.479 222.196 408.787 222.587 408.981C222.979 409.176 223.418 409.248 223.85 409.189C224.282 409.13 224.687 408.943 225.013 408.65C225.451 408.258 225.718 407.706 225.755 407.115C225.792 406.523 225.595 405.941 225.209 405.496Z",
    fill: "url(#paint20_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M219.633 409.959C219.448 409.744 219.204 409.59 218.933 409.515C218.662 409.441 218.375 409.45 218.109 409.542C217.843 409.633 217.609 409.803 217.438 410.029C217.267 410.255 217.166 410.527 217.148 410.812C217.129 411.096 217.195 411.38 217.335 411.627C217.476 411.874 217.686 412.073 217.938 412.198C218.19 412.324 218.473 412.371 218.752 412.333C219.03 412.296 219.291 412.175 219.502 411.986C219.784 411.734 219.955 411.38 219.98 411C220.004 410.62 219.88 410.245 219.633 409.959Z",
    fill: "url(#paint21_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M251.307 401.371C251.122 401.157 250.878 401.004 250.607 400.931C250.335 400.858 250.049 400.868 249.783 400.96C249.517 401.053 249.285 401.223 249.114 401.449C248.944 401.675 248.844 401.948 248.826 402.232C248.808 402.517 248.874 402.8 249.015 403.046C249.156 403.292 249.366 403.491 249.618 403.616C249.87 403.741 250.153 403.788 250.431 403.75C250.71 403.712 250.971 403.591 251.181 403.403C251.321 403.278 251.436 403.127 251.518 402.957C251.601 402.787 251.649 402.602 251.661 402.414C251.672 402.225 251.647 402.035 251.587 401.857C251.526 401.678 251.431 401.513 251.307 401.371Z",
    fill: "url(#paint22_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M210.142 420.33C210.109 420.275 210.065 420.228 210.012 420.192C209.959 420.157 209.899 420.133 209.836 420.123C209.773 420.113 209.709 420.118 209.648 420.136C209.587 420.154 209.531 420.185 209.483 420.228C209.435 420.271 209.397 420.323 209.372 420.382C209.346 420.441 209.334 420.505 209.335 420.57C209.336 420.634 209.352 420.698 209.38 420.755C209.408 420.813 209.448 420.864 209.498 420.904C209.531 420.96 209.575 421.007 209.628 421.042C209.681 421.078 209.741 421.102 209.804 421.111C209.867 421.121 209.931 421.117 209.992 421.099C210.053 421.081 210.109 421.049 210.157 421.007C210.205 420.964 210.243 420.911 210.268 420.852C210.294 420.793 210.306 420.729 210.305 420.665C210.303 420.6 210.288 420.537 210.26 420.479C210.232 420.421 210.192 420.371 210.142 420.33Z",
    fill: "url(#paint23_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M228.011 418.284C227.955 418.217 227.88 418.169 227.797 418.145C227.713 418.122 227.625 418.124 227.542 418.151C227.46 418.179 227.388 418.231 227.335 418.301C227.282 418.37 227.251 418.454 227.245 418.542C227.239 418.63 227.26 418.717 227.303 418.793C227.347 418.869 227.412 418.93 227.49 418.968C227.568 419.007 227.656 419.02 227.741 419.008C227.827 418.995 227.907 418.957 227.972 418.898C228.056 418.821 228.107 418.714 228.114 418.599C228.121 418.485 228.084 418.372 228.011 418.284Z",
    fill: "url(#paint24_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M262.053 413.756C261.997 413.689 261.922 413.641 261.839 413.617C261.755 413.594 261.667 413.596 261.584 413.624C261.502 413.651 261.43 413.703 261.377 413.773C261.324 413.842 261.293 413.927 261.287 414.014C261.281 414.102 261.302 414.19 261.345 414.265C261.389 414.341 261.454 414.402 261.532 414.441C261.61 414.479 261.698 414.493 261.783 414.48C261.869 414.468 261.949 414.429 262.014 414.37C262.098 414.293 262.149 414.186 262.156 414.071C262.163 413.957 262.126 413.844 262.053 413.756Z",
    fill: "url(#paint25_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M256.537 417.564C256.46 417.479 256.353 417.427 256.239 417.42C256.125 417.414 256.013 417.453 255.927 417.529C255.843 417.606 255.792 417.713 255.785 417.828C255.778 417.943 255.815 418.056 255.888 418.143C255.968 418.214 256.07 418.253 256.176 418.254C256.282 418.254 256.384 418.215 256.464 418.144C256.543 418.073 256.595 417.975 256.608 417.868C256.621 417.761 256.596 417.653 256.537 417.564Z",
    fill: "url(#paint26_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M230.011 431.603C229.326 430.82 228.428 430.26 227.431 429.994C226.433 429.728 225.38 429.768 224.405 430.108C223.429 430.449 222.575 431.074 221.949 431.907C221.324 432.739 220.955 433.741 220.889 434.785C220.824 435.83 221.065 436.871 221.582 437.777C222.098 438.682 222.868 439.413 223.793 439.876C224.718 440.339 225.758 440.513 226.781 440.377C227.804 440.242 228.764 439.801 229.541 439.113C230.06 438.652 230.484 438.092 230.789 437.465C231.094 436.838 231.273 436.155 231.317 435.457C231.36 434.759 231.268 434.059 231.043 433.398C230.819 432.736 230.468 432.126 230.011 431.603Z",
    fill: "url(#paint27_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M240.724 412.742C240.384 412.347 239.935 412.063 239.435 411.928C238.935 411.792 238.407 411.81 237.917 411.979C237.428 412.148 236.998 412.461 236.684 412.878C236.37 413.295 236.185 413.798 236.153 414.322C236.12 414.846 236.242 415.368 236.502 415.821C236.762 416.275 237.15 416.64 237.615 416.87C238.08 417.1 238.602 417.185 239.114 417.114C239.627 417.042 240.107 416.818 240.494 416.47C241.01 416.005 241.323 415.352 241.366 414.654C241.41 413.955 241.179 413.268 240.724 412.742Z",
    fill: "url(#paint28_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.189 430.521C196.849 430.126 196.4 429.842 195.901 429.706C195.401 429.569 194.873 429.587 194.383 429.755C193.893 429.924 193.464 430.237 193.149 430.653C192.834 431.07 192.649 431.572 192.616 432.096C192.583 432.62 192.704 433.142 192.963 433.596C193.223 434.05 193.61 434.415 194.075 434.646C194.539 434.877 195.061 434.962 195.574 434.892C196.086 434.821 196.567 434.597 196.954 434.249C197.471 433.785 197.785 433.133 197.829 432.434C197.873 431.736 197.643 431.048 197.189 430.521Z",
    fill: "url(#paint29_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M225.792 374.141C225.451 373.746 225.003 373.462 224.503 373.326C224.003 373.189 223.474 373.207 222.984 373.376C222.494 373.545 222.065 373.858 221.75 374.275C221.436 374.692 221.251 375.195 221.218 375.719C221.186 376.243 221.307 376.765 221.568 377.219C221.828 377.673 222.216 378.038 222.681 378.268C223.147 378.498 223.669 378.583 224.182 378.511C224.694 378.439 225.175 378.215 225.561 377.865C226.076 377.401 226.389 376.749 226.432 376.052C226.475 375.354 226.245 374.668 225.792 374.141Z",
    fill: "url(#paint30_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M179.646 391.749C179.305 391.353 178.856 391.069 178.356 390.933C177.857 390.797 177.328 390.814 176.838 390.983C176.348 391.152 175.918 391.465 175.604 391.882C175.289 392.3 175.104 392.802 175.072 393.326C175.039 393.851 175.161 394.373 175.421 394.827C175.682 395.281 176.069 395.646 176.535 395.876C177 396.106 177.522 396.19 178.035 396.118C178.548 396.047 179.028 395.822 179.415 395.473C179.929 395.008 180.242 394.356 180.285 393.659C180.329 392.962 180.099 392.275 179.646 391.749Z",
    fill: "url(#paint31_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.614 357.139C185.45 356.95 185.235 356.815 184.995 356.75C184.755 356.686 184.502 356.695 184.268 356.776C184.033 356.858 183.828 357.008 183.678 357.208C183.527 357.408 183.438 357.648 183.422 357.899C183.407 358.15 183.465 358.4 183.589 358.618C183.713 358.835 183.898 359.011 184.12 359.122C184.343 359.233 184.593 359.274 184.838 359.241C185.084 359.208 185.314 359.102 185.501 358.936C185.625 358.826 185.726 358.692 185.799 358.542C185.872 358.392 185.914 358.228 185.925 358.061C185.935 357.894 185.913 357.727 185.86 357.568C185.807 357.41 185.723 357.264 185.614 357.139Z",
    fill: "url(#paint32_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M261.46 424.899C261.261 424.67 260.999 424.506 260.708 424.427C260.417 424.349 260.11 424.36 259.825 424.459C259.54 424.557 259.29 424.739 259.107 424.982C258.925 425.225 258.817 425.517 258.797 425.822C258.778 426.127 258.848 426.431 258.998 426.695C259.149 426.96 259.373 427.173 259.643 427.308C259.913 427.443 260.217 427.494 260.515 427.455C260.814 427.415 261.094 427.286 261.321 427.085C261.625 426.814 261.81 426.431 261.836 426.021C261.862 425.611 261.727 425.207 261.46 424.899Z",
    fill: "url(#paint33_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.169 426.497C217.97 426.267 217.708 426.103 217.417 426.025C217.126 425.946 216.818 425.957 216.533 426.057C216.248 426.156 215.998 426.338 215.815 426.581C215.632 426.825 215.525 427.117 215.506 427.422C215.487 427.728 215.558 428.032 215.709 428.296C215.861 428.56 216.086 428.773 216.357 428.908C216.627 429.042 216.931 429.092 217.23 429.052C217.528 429.011 217.808 428.881 218.034 428.679C218.185 428.545 218.308 428.382 218.396 428.2C218.485 428.017 218.537 427.819 218.549 427.616C218.562 427.413 218.535 427.21 218.469 427.018C218.404 426.826 218.302 426.649 218.169 426.497Z",
    fill: "url(#paint34_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M245.383 436.139C245.242 435.978 245.058 435.862 244.852 435.807C244.647 435.752 244.43 435.76 244.229 435.829C244.027 435.899 243.851 436.028 243.722 436.2C243.593 436.371 243.517 436.578 243.504 436.793C243.491 437.008 243.541 437.223 243.647 437.409C243.754 437.596 243.913 437.746 244.104 437.841C244.294 437.936 244.509 437.972 244.719 437.943C244.93 437.915 245.128 437.823 245.287 437.681C245.501 437.489 245.631 437.219 245.649 436.93C245.667 436.641 245.571 436.357 245.383 436.139Z",
    fill: "url(#paint35_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M250.768 404.511C250.628 404.349 250.443 404.232 250.237 404.177C250.032 404.121 249.814 404.128 249.613 404.198C249.412 404.268 249.235 404.397 249.106 404.568C248.977 404.74 248.9 404.946 248.887 405.162C248.873 405.377 248.923 405.592 249.03 405.779C249.137 405.966 249.296 406.116 249.488 406.211C249.679 406.306 249.893 406.341 250.104 406.312C250.315 406.283 250.513 406.191 250.672 406.048C250.778 405.954 250.865 405.839 250.927 405.711C250.99 405.582 251.026 405.443 251.035 405.3C251.044 405.157 251.025 405.014 250.979 404.878C250.933 404.743 250.862 404.618 250.768 404.511Z",
    fill: "url(#paint36_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.258 429.429C246.912 429.031 246.457 428.745 245.951 428.609C245.445 428.473 244.91 428.492 244.415 428.664C243.919 428.836 243.486 429.153 243.168 429.575C242.85 429.998 242.663 430.506 242.63 431.036C242.597 431.566 242.72 432.095 242.983 432.554C243.246 433.013 243.637 433.383 244.108 433.617C244.578 433.85 245.106 433.937 245.625 433.867C246.143 433.796 246.63 433.571 247.023 433.219C247.549 432.748 247.869 432.084 247.914 431.374C247.958 430.663 247.722 429.963 247.258 429.429Z",
    fill: "url(#paint37_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M220.787 348.556C220.303 348.003 219.67 347.608 218.965 347.42C218.261 347.233 217.518 347.261 216.83 347.501C216.141 347.742 215.538 348.184 215.097 348.771C214.655 349.359 214.395 350.066 214.349 350.803C214.303 351.54 214.473 352.275 214.838 352.914C215.203 353.554 215.746 354.069 216.399 354.396C217.052 354.722 217.786 354.845 218.508 354.749C219.23 354.653 219.908 354.343 220.456 353.856C220.822 353.531 221.121 353.136 221.335 352.693C221.55 352.25 221.677 351.768 221.707 351.276C221.738 350.783 221.673 350.289 221.515 349.822C221.357 349.356 221.109 348.925 220.787 348.556Z",
    fill: "url(#paint38_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M231.133 353.093C230.845 352.761 230.467 352.524 230.045 352.41C229.624 352.297 229.179 352.313 228.767 352.456C228.355 352.599 227.994 352.863 227.729 353.214C227.465 353.566 227.309 353.989 227.282 354.43C227.254 354.871 227.356 355.311 227.575 355.693C227.794 356.076 228.12 356.383 228.511 356.578C228.902 356.772 229.342 356.845 229.774 356.786C230.205 356.727 230.61 356.54 230.937 356.247C231.155 356.053 231.332 355.818 231.46 355.554C231.587 355.291 231.662 355.004 231.68 354.711C231.699 354.418 231.66 354.125 231.566 353.847C231.472 353.569 231.325 353.313 231.133 353.093Z",
    fill: "url(#paint39_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M225.552 357.536C225.367 357.322 225.123 357.169 224.852 357.096C224.58 357.022 224.294 357.033 224.028 357.125C223.763 357.217 223.53 357.387 223.36 357.614C223.189 357.84 223.089 358.113 223.071 358.397C223.054 358.681 223.119 358.964 223.26 359.211C223.401 359.457 223.611 359.655 223.863 359.781C224.115 359.906 224.398 359.953 224.677 359.915C224.955 359.877 225.216 359.756 225.426 359.568C225.708 359.315 225.88 358.959 225.904 358.578C225.928 358.197 225.801 357.822 225.552 357.536Z",
    fill: "url(#paint40_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M257.233 348.971C257.048 348.757 256.804 348.603 256.533 348.529C256.261 348.456 255.975 348.465 255.709 348.557C255.443 348.649 255.209 348.819 255.039 349.046C254.868 349.272 254.768 349.545 254.75 349.83C254.732 350.114 254.798 350.398 254.939 350.644C255.081 350.891 255.291 351.089 255.543 351.214C255.796 351.34 256.079 351.386 256.357 351.347C256.636 351.309 256.897 351.188 257.107 350.999C257.388 350.746 257.559 350.391 257.583 350.011C257.606 349.631 257.481 349.257 257.233 348.971Z",
    fill: "url(#paint41_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M216.065 367.927C215.989 367.841 215.883 367.79 215.77 367.782C215.657 367.775 215.546 367.812 215.46 367.887C215.375 367.964 215.323 368.072 215.315 368.188C215.308 368.304 215.346 368.418 215.421 368.505C215.501 368.573 215.602 368.609 215.706 368.607C215.809 368.605 215.909 368.566 215.987 368.496C216.065 368.426 216.116 368.33 216.13 368.226C216.144 368.121 216.121 368.015 216.065 367.927Z",
    fill: "url(#paint42_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M233.938 365.882C233.862 365.796 233.756 365.745 233.643 365.737C233.53 365.73 233.419 365.767 233.333 365.842C233.248 365.919 233.196 366.027 233.188 366.143C233.181 366.259 233.219 366.373 233.294 366.46C233.37 366.545 233.475 366.597 233.588 366.605C233.701 366.612 233.813 366.575 233.899 366.5C233.984 366.423 234.036 366.315 234.043 366.199C234.05 366.083 234.013 365.969 233.938 365.882Z",
    fill: "url(#paint43_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M267.976 361.366C267.9 361.281 267.794 361.23 267.681 361.222C267.568 361.215 267.457 361.252 267.371 361.327C267.286 361.404 267.234 361.512 267.226 361.628C267.219 361.743 267.257 361.857 267.332 361.945C267.408 362.03 267.513 362.082 267.626 362.09C267.739 362.097 267.851 362.059 267.937 361.985C268.022 361.908 268.074 361.8 268.081 361.684C268.089 361.568 268.051 361.454 267.976 361.366Z",
    fill: "url(#paint44_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M262.463 365.166C262.387 365.079 262.28 365.026 262.166 365.019C262.052 365.012 261.94 365.05 261.853 365.126C261.769 365.203 261.718 365.31 261.711 365.425C261.704 365.539 261.741 365.652 261.814 365.74C261.89 365.826 261.997 365.879 262.111 365.886C262.225 365.894 262.337 365.855 262.423 365.78C262.507 365.702 262.558 365.595 262.566 365.481C262.573 365.366 262.536 365.253 262.463 365.166Z",
    fill: "url(#paint45_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M235.936 379.177C235.251 378.394 234.353 377.835 233.356 377.569C232.358 377.303 231.305 377.342 230.329 377.683C229.354 378.023 228.499 378.649 227.874 379.481C227.248 380.313 226.88 381.315 226.814 382.359C226.749 383.404 226.99 384.445 227.506 385.351C228.023 386.257 228.793 386.987 229.718 387.45C230.643 387.913 231.683 388.087 232.706 387.951C233.728 387.816 234.689 387.376 235.465 386.687C235.985 386.227 236.409 385.667 236.714 385.039C237.018 384.412 237.198 383.73 237.241 383.031C237.285 382.333 237.192 381.633 236.968 380.972C236.744 380.311 236.393 379.701 235.936 379.177Z",
    fill: "url(#paint46_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M246.65 360.337C246.309 359.942 245.861 359.659 245.361 359.523C244.861 359.387 244.333 359.405 243.843 359.574C243.353 359.743 242.924 360.056 242.61 360.474C242.296 360.891 242.111 361.393 242.078 361.917C242.046 362.441 242.168 362.963 242.428 363.416C242.688 363.87 243.075 364.235 243.54 364.465C244.005 364.695 244.527 364.78 245.04 364.709C245.552 364.638 246.033 364.414 246.42 364.065C246.935 363.6 247.249 362.948 247.292 362.249C247.336 361.551 247.105 360.863 246.65 360.337Z",
    fill: "url(#paint47_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M203.115 378.121C202.774 377.726 202.325 377.443 201.826 377.307C201.326 377.171 200.798 377.189 200.308 377.358C199.818 377.528 199.389 377.841 199.075 378.258C198.761 378.675 198.576 379.177 198.543 379.701C198.511 380.225 198.632 380.747 198.893 381.201C199.153 381.654 199.54 382.019 200.005 382.25C200.47 382.48 200.992 382.564 201.505 382.493C202.017 382.422 202.497 382.198 202.884 381.849C203.4 381.385 203.714 380.732 203.757 380.033C203.8 379.335 203.57 378.647 203.115 378.121Z",
    fill: "url(#paint48_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M231.721 321.738C231.381 321.343 230.933 321.059 230.433 320.922C229.933 320.786 229.405 320.803 228.915 320.972C228.425 321.141 227.996 321.453 227.681 321.87C227.367 322.287 227.181 322.789 227.148 323.313C227.115 323.837 227.236 324.359 227.496 324.813C227.755 325.267 228.142 325.632 228.607 325.863C229.072 326.094 229.593 326.179 230.106 326.108C230.619 326.038 231.099 325.814 231.486 325.466C232.003 325.002 232.317 324.35 232.361 323.651C232.405 322.953 232.175 322.265 231.721 321.738Z",
    fill: "url(#paint49_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M185.569 339.347C185.228 338.952 184.78 338.668 184.28 338.533C183.78 338.397 183.252 338.415 182.762 338.584C182.272 338.753 181.843 339.066 181.529 339.483C181.215 339.9 181.03 340.403 180.997 340.927C180.965 341.451 181.087 341.973 181.347 342.426C181.607 342.88 181.994 343.245 182.459 343.475C182.924 343.705 183.446 343.79 183.959 343.719C184.471 343.647 184.952 343.423 185.338 343.075C185.854 342.61 186.168 341.957 186.211 341.259C186.254 340.56 186.024 339.873 185.569 339.347Z",
    fill: "url(#paint50_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.543 304.74C191.379 304.551 191.164 304.415 190.924 304.35C190.684 304.285 190.431 304.294 190.196 304.375C189.961 304.456 189.756 304.606 189.605 304.806C189.454 305.006 189.365 305.247 189.349 305.498C189.333 305.749 189.391 306 189.516 306.217C189.64 306.435 189.826 306.611 190.048 306.721C190.271 306.832 190.521 306.874 190.767 306.84C191.013 306.807 191.244 306.7 191.43 306.534C191.679 306.311 191.83 305.997 191.852 305.661C191.873 305.324 191.762 304.993 191.543 304.74Z",
    fill: "url(#paint51_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M267.385 372.498C267.186 372.268 266.924 372.104 266.633 372.026C266.341 371.947 266.034 371.958 265.749 372.058C265.464 372.157 265.214 372.339 265.031 372.582C264.848 372.826 264.741 373.118 264.722 373.423C264.703 373.729 264.774 374.033 264.925 374.297C265.076 374.561 265.302 374.774 265.572 374.909C265.843 375.043 266.147 375.093 266.446 375.052C266.744 375.012 267.024 374.882 267.25 374.68C267.401 374.546 267.524 374.383 267.612 374.201C267.701 374.018 267.752 373.82 267.765 373.617C267.778 373.414 267.75 373.211 267.685 373.019C267.62 372.827 267.518 372.65 267.385 372.498Z",
    fill: "url(#paint52_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.093 374.093C223.894 373.864 223.632 373.7 223.341 373.621C223.049 373.543 222.742 373.554 222.457 373.653C222.172 373.752 221.922 373.935 221.739 374.178C221.556 374.421 221.449 374.714 221.43 375.019C221.411 375.324 221.482 375.628 221.633 375.893C221.784 376.157 222.01 376.37 222.28 376.504C222.551 376.639 222.855 376.689 223.154 376.648C223.452 376.607 223.732 376.478 223.958 376.275C224.26 376.004 224.444 375.621 224.469 375.213C224.495 374.804 224.359 374.401 224.093 374.093Z",
    fill: "url(#paint53_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M251.307 383.736C251.166 383.574 250.981 383.459 250.776 383.403C250.57 383.348 250.353 383.356 250.152 383.426C249.951 383.496 249.775 383.625 249.646 383.796C249.517 383.968 249.441 384.174 249.428 384.39C249.415 384.605 249.464 384.819 249.571 385.006C249.678 385.193 249.837 385.343 250.027 385.438C250.218 385.533 250.433 385.568 250.643 385.54C250.854 385.511 251.052 385.42 251.211 385.278C251.425 385.086 251.555 384.816 251.572 384.527C251.59 384.238 251.495 383.954 251.307 383.736Z",
    fill: "url(#paint54_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M256.694 352.09C256.553 351.928 256.368 351.813 256.163 351.757C255.957 351.702 255.74 351.71 255.539 351.78C255.338 351.85 255.162 351.979 255.033 352.15C254.904 352.322 254.828 352.528 254.815 352.744C254.801 352.959 254.851 353.173 254.958 353.36C255.064 353.546 255.223 353.697 255.414 353.792C255.605 353.887 255.819 353.922 256.03 353.894C256.241 353.865 256.438 353.774 256.598 353.632C256.704 353.537 256.791 353.422 256.853 353.293C256.915 353.164 256.952 353.024 256.961 352.881C256.97 352.738 256.951 352.594 256.905 352.458C256.859 352.323 256.787 352.197 256.694 352.09Z",
    fill: "url(#paint55_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.188 377.027C252.843 376.628 252.388 376.342 251.882 376.205C251.376 376.069 250.842 376.087 250.346 376.258C249.851 376.43 249.417 376.747 249.098 377.169C248.78 377.59 248.593 378.099 248.559 378.629C248.526 379.159 248.648 379.687 248.91 380.147C249.173 380.606 249.564 380.977 250.033 381.211C250.503 381.445 251.031 381.533 251.55 381.463C252.069 381.393 252.556 381.168 252.949 380.817C253.475 380.346 253.795 379.683 253.84 378.972C253.885 378.262 253.651 377.562 253.188 377.027Z",
    fill: "url(#paint56_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M202.074 300.163C201.591 299.611 200.957 299.216 200.253 299.028C199.548 298.841 198.805 298.869 198.117 299.109C197.428 299.35 196.825 299.791 196.384 300.379C195.942 300.967 195.682 301.673 195.636 302.411C195.59 303.148 195.76 303.883 196.125 304.522C196.49 305.161 197.033 305.677 197.686 306.003C198.339 306.33 199.073 306.453 199.795 306.357C200.517 306.261 201.195 305.951 201.743 305.464C202.109 305.139 202.409 304.744 202.624 304.301C202.839 303.858 202.966 303.377 202.996 302.884C203.027 302.391 202.961 301.897 202.803 301.43C202.645 300.963 202.397 300.533 202.074 300.163Z",
    fill: "url(#paint57_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M212.422 304.7C212.134 304.368 211.756 304.13 211.334 304.017C210.913 303.903 210.468 303.919 210.056 304.062C209.644 304.205 209.283 304.469 209.018 304.821C208.754 305.172 208.598 305.595 208.571 306.036C208.543 306.478 208.646 306.917 208.864 307.3C209.083 307.682 209.409 307.99 209.8 308.184C210.191 308.379 210.631 308.451 211.063 308.392C211.495 308.333 211.899 308.146 212.226 307.854C212.444 307.66 212.621 307.424 212.749 307.161C212.876 306.897 212.951 306.611 212.97 306.318C212.988 306.025 212.949 305.731 212.855 305.453C212.761 305.176 212.614 304.919 212.422 304.7Z",
    fill: "url(#paint58_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M206.841 309.144C206.655 308.931 206.411 308.778 206.14 308.704C205.868 308.631 205.582 308.642 205.316 308.734C205.051 308.826 204.818 308.996 204.648 309.222C204.477 309.449 204.377 309.721 204.359 310.006C204.342 310.29 204.407 310.573 204.548 310.82C204.689 311.066 204.899 311.264 205.151 311.39C205.403 311.515 205.686 311.561 205.965 311.524C206.243 311.486 206.504 311.365 206.714 311.176C206.855 311.052 206.969 310.9 207.051 310.73C207.134 310.56 207.182 310.376 207.194 310.187C207.206 309.998 207.18 309.809 207.12 309.63C207.059 309.451 206.964 309.286 206.841 309.144Z",
    fill: "url(#paint59_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M199.193 477.615C199.008 477.401 198.764 477.247 198.493 477.173C198.222 477.1 197.935 477.109 197.67 477.201C197.404 477.293 197.171 477.462 197 477.688C196.829 477.914 196.728 478.187 196.71 478.471C196.692 478.755 196.757 479.038 196.897 479.285C197.038 479.532 197.247 479.731 197.499 479.856C197.751 479.982 198.034 480.03 198.312 479.992C198.59 479.955 198.852 479.835 199.062 479.647C199.345 479.395 199.518 479.039 199.542 478.658C199.567 478.277 199.441 477.902 199.193 477.615Z",
    fill: "url(#paint60_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.356 319.534C197.299 319.467 197.225 319.418 197.141 319.395C197.058 319.371 196.969 319.373 196.887 319.401C196.805 319.429 196.733 319.481 196.68 319.55C196.627 319.62 196.595 319.704 196.59 319.792C196.584 319.879 196.605 319.967 196.648 320.043C196.692 320.119 196.757 320.18 196.835 320.218C196.913 320.256 197 320.27 197.086 320.257C197.172 320.245 197.252 320.207 197.316 320.148C197.4 320.071 197.451 319.963 197.459 319.849C197.466 319.734 197.429 319.621 197.356 319.534Z",
    fill: "url(#paint61_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M215.227 317.489C215.151 317.404 215.045 317.352 214.932 317.345C214.819 317.337 214.708 317.375 214.622 317.449C214.537 317.527 214.485 317.635 214.477 317.75C214.47 317.866 214.508 317.98 214.583 318.068C214.663 318.135 214.764 318.171 214.868 318.169C214.972 318.168 215.071 318.128 215.149 318.059C215.227 317.989 215.278 317.893 215.292 317.788C215.306 317.684 215.283 317.578 215.227 317.489Z",
    fill: "url(#paint62_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M209.937 490C209.861 489.914 209.755 489.861 209.64 489.854C209.526 489.847 209.414 489.885 209.328 489.961C209.244 490.038 209.193 490.145 209.185 490.26C209.178 490.374 209.215 490.487 209.289 490.575C209.365 490.661 209.471 490.714 209.585 490.721C209.699 490.729 209.812 490.69 209.898 490.615C209.982 490.537 210.033 490.43 210.04 490.316C210.048 490.201 210.011 490.088 209.937 490Z",
    fill: "url(#paint63_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M204.416 493.808C204.359 493.742 204.285 493.694 204.201 493.671C204.118 493.648 204.03 493.65 203.948 493.678C203.866 493.706 203.794 493.758 203.742 493.828C203.689 493.897 203.658 493.981 203.652 494.069C203.647 494.156 203.667 494.243 203.71 494.319C203.754 494.395 203.819 494.456 203.896 494.494C203.974 494.533 204.061 494.547 204.147 494.535C204.232 494.522 204.312 494.485 204.377 494.426C204.462 494.349 204.514 494.241 204.521 494.125C204.529 494.01 204.491 493.896 204.416 493.808Z",
    fill: "url(#paint64_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M217.225 330.784C216.54 330.001 215.642 329.442 214.645 329.176C213.647 328.91 212.594 328.949 211.618 329.289C210.643 329.63 209.789 330.255 209.163 331.088C208.537 331.92 208.169 332.922 208.103 333.966C208.038 335.011 208.279 336.052 208.795 336.958C209.312 337.864 210.082 338.594 211.007 339.057C211.932 339.52 212.972 339.694 213.995 339.558C215.017 339.423 215.978 338.983 216.755 338.294C217.274 337.834 217.698 337.274 218.003 336.646C218.307 336.019 218.487 335.336 218.531 334.638C218.574 333.94 218.481 333.24 218.257 332.579C218.033 331.917 217.682 331.308 217.225 330.784Z",
    fill: "url(#paint65_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M188.611 488.985C188.271 488.59 187.822 488.306 187.323 488.17C186.823 488.033 186.295 488.05 185.805 488.219C185.315 488.388 184.885 488.7 184.571 489.117C184.256 489.534 184.071 490.036 184.038 490.56C184.005 491.084 184.126 491.606 184.385 492.06C184.645 492.514 185.032 492.879 185.497 493.11C185.961 493.341 186.483 493.426 186.996 493.355C187.508 493.285 187.989 493.061 188.376 492.713C188.892 492.249 189.207 491.597 189.251 490.898C189.295 490.2 189.065 489.512 188.611 488.985Z",
    fill: "url(#paint66_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M199.42 335.767C199.079 335.371 198.631 335.088 198.131 334.951C197.632 334.815 197.103 334.832 196.613 335.001C196.124 335.17 195.694 335.482 195.379 335.899C195.065 336.316 194.879 336.818 194.846 337.342C194.813 337.865 194.934 338.387 195.194 338.841C195.454 339.295 195.84 339.661 196.305 339.892C196.77 340.122 197.292 340.208 197.804 340.137C198.317 340.067 198.797 339.843 199.185 339.495C199.701 339.031 200.016 338.379 200.06 337.68C200.104 336.982 199.874 336.294 199.42 335.767Z",
    fill: "url(#paint67_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M209.345 501.142C209.144 500.916 208.882 500.755 208.592 500.679C208.301 500.604 207.995 500.617 207.712 500.717C207.429 500.817 207.181 500.999 207 501.241C206.819 501.484 206.712 501.775 206.693 502.078C206.673 502.382 206.743 502.684 206.892 502.948C207.042 503.212 207.265 503.425 207.533 503.56C207.801 503.696 208.103 503.749 208.4 503.711C208.698 503.674 208.978 503.548 209.205 503.35C209.359 503.216 209.485 503.051 209.575 502.867C209.666 502.682 209.719 502.481 209.732 502.276C209.745 502.07 209.717 501.864 209.651 501.669C209.584 501.474 209.48 501.295 209.345 501.142Z",
    fill: "url(#paint68_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.382 325.701C205.183 325.472 204.921 325.308 204.63 325.229C204.338 325.151 204.031 325.162 203.746 325.261C203.461 325.36 203.211 325.543 203.028 325.786C202.845 326.029 202.738 326.322 202.719 326.627C202.7 326.932 202.771 327.236 202.922 327.501C203.073 327.765 203.299 327.978 203.569 328.112C203.84 328.247 204.144 328.297 204.443 328.256C204.741 328.215 205.021 328.086 205.247 327.883C205.398 327.749 205.521 327.587 205.609 327.404C205.698 327.222 205.75 327.024 205.762 326.821C205.775 326.618 205.748 326.415 205.682 326.223C205.617 326.03 205.515 325.853 205.382 325.701Z",
    fill: "url(#paint69_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M249.235 306.003C248.752 305.451 248.118 305.056 247.414 304.868C246.71 304.681 245.966 304.709 245.278 304.949C244.589 305.189 243.986 305.631 243.545 306.219C243.104 306.806 242.843 307.513 242.797 308.251C242.751 308.988 242.922 309.723 243.286 310.362C243.651 311.001 244.194 311.517 244.848 311.843C245.501 312.17 246.234 312.293 246.956 312.197C247.678 312.101 248.356 311.79 248.904 311.304C249.27 310.979 249.569 310.583 249.784 310.141C249.998 309.698 250.125 309.216 250.156 308.723C250.186 308.231 250.121 307.737 249.963 307.27C249.805 306.803 249.558 306.373 249.235 306.003Z",
    fill: "url(#paint70_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M259.575 310.539C259.287 310.208 258.909 309.97 258.488 309.857C258.067 309.743 257.622 309.759 257.21 309.902C256.797 310.045 256.436 310.309 256.172 310.661C255.907 311.012 255.751 311.435 255.724 311.876C255.697 312.318 255.799 312.757 256.018 313.14C256.237 313.522 256.562 313.83 256.953 314.024C257.345 314.219 257.784 314.291 258.216 314.232C258.648 314.173 259.053 313.986 259.38 313.693C259.818 313.301 260.084 312.749 260.121 312.158C260.158 311.566 259.962 310.984 259.575 310.539Z",
    fill: "url(#paint71_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M253.995 314.984C253.809 314.771 253.565 314.617 253.294 314.544C253.023 314.471 252.736 314.481 252.471 314.574C252.205 314.666 251.972 314.836 251.802 315.062C251.632 315.289 251.531 315.561 251.514 315.846C251.496 316.13 251.562 316.413 251.703 316.659C251.844 316.906 252.053 317.104 252.306 317.229C252.558 317.355 252.841 317.401 253.119 317.363C253.397 317.325 253.658 317.205 253.869 317.016C254.151 316.764 254.323 316.408 254.346 316.027C254.37 315.646 254.244 315.271 253.995 314.984Z",
    fill: "url(#paint72_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M244.509 325.373C244.453 325.307 244.378 325.258 244.295 325.235C244.211 325.211 244.123 325.213 244.04 325.241C243.958 325.268 243.886 325.32 243.833 325.39C243.78 325.46 243.749 325.544 243.743 325.631C243.737 325.719 243.758 325.807 243.802 325.883C243.845 325.959 243.91 326.02 243.988 326.058C244.066 326.096 244.154 326.11 244.24 326.097C244.325 326.085 244.405 326.047 244.47 325.987C244.554 325.91 244.605 325.803 244.612 325.689C244.619 325.574 244.582 325.461 244.509 325.373Z",
    fill: "url(#paint73_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M262.378 323.328C262.302 323.243 262.197 323.191 262.084 323.184C261.971 323.176 261.859 323.214 261.773 323.288C261.688 323.365 261.636 323.474 261.629 323.589C261.621 323.705 261.659 323.819 261.734 323.907C261.814 323.974 261.915 324.01 262.019 324.008C262.123 324.007 262.223 323.967 262.301 323.897C262.378 323.828 262.429 323.732 262.443 323.627C262.458 323.523 262.435 323.417 262.378 323.328Z",
    fill: "url(#paint74_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M264.378 336.63C263.693 335.847 262.796 335.287 261.798 335.021C260.8 334.755 259.747 334.794 258.772 335.135C257.796 335.475 256.942 336.101 256.316 336.933C255.691 337.765 255.322 338.767 255.257 339.811C255.191 340.856 255.432 341.897 255.949 342.803C256.466 343.709 257.235 344.439 258.16 344.902C259.085 345.365 260.125 345.539 261.148 345.404C262.171 345.268 263.131 344.828 263.908 344.139C264.427 343.679 264.851 343.119 265.156 342.491C265.461 341.864 265.64 341.182 265.684 340.484C265.728 339.786 265.635 339.086 265.411 338.424C265.186 337.763 264.836 337.153 264.378 336.63Z",
    fill: "url(#paint75_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M246.566 341.608C246.225 341.213 245.777 340.93 245.277 340.794C244.777 340.658 244.249 340.676 243.759 340.845C243.269 341.014 242.84 341.327 242.526 341.745C242.212 342.162 242.027 342.664 241.994 343.188C241.962 343.712 242.084 344.234 242.344 344.687C242.604 345.141 242.991 345.506 243.456 345.736C243.921 345.966 244.443 346.051 244.956 345.98C245.468 345.909 245.949 345.685 246.336 345.336C246.851 344.871 247.165 344.219 247.208 343.52C247.251 342.822 247.021 342.134 246.566 341.608Z",
    fill: "url(#paint76_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.535 331.54C252.335 331.311 252.073 331.146 251.782 331.068C251.491 330.99 251.183 331.001 250.898 331.1C250.613 331.199 250.363 331.382 250.18 331.625C249.998 331.868 249.89 332.161 249.871 332.466C249.852 332.771 249.923 333.075 250.074 333.339C250.226 333.604 250.451 333.817 250.722 333.951C250.992 334.086 251.296 334.136 251.595 334.095C251.894 334.054 252.174 333.925 252.4 333.722C252.55 333.588 252.673 333.425 252.762 333.243C252.85 333.061 252.902 332.862 252.914 332.66C252.927 332.457 252.9 332.254 252.835 332.061C252.77 331.869 252.668 331.692 252.535 331.54Z",
    fill: "url(#paint77_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M193.262 512.385C193.121 512.224 192.937 512.108 192.731 512.053C192.526 511.998 192.309 512.006 192.107 512.076C191.906 512.146 191.73 512.274 191.601 512.446C191.472 512.617 191.396 512.824 191.383 513.039C191.37 513.254 191.419 513.469 191.526 513.655C191.633 513.842 191.792 513.992 191.982 514.087C192.173 514.182 192.388 514.218 192.598 514.189C192.809 514.161 193.007 514.069 193.166 513.927C193.272 513.832 193.359 513.717 193.421 513.588C193.484 513.46 193.52 513.32 193.529 513.176C193.538 513.033 193.519 512.89 193.473 512.754C193.427 512.618 193.356 512.493 193.262 512.385Z",
    fill: "url(#paint78_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M198.654 480.756C198.513 480.593 198.329 480.477 198.123 480.421C197.917 480.365 197.7 480.373 197.499 480.443C197.297 480.512 197.121 480.641 196.991 480.813C196.862 480.984 196.786 481.191 196.773 481.407C196.759 481.622 196.809 481.837 196.916 482.024C197.023 482.21 197.182 482.361 197.373 482.455C197.564 482.55 197.779 482.586 197.99 482.557C198.201 482.528 198.399 482.436 198.558 482.293C198.771 482.102 198.901 481.832 198.919 481.544C198.937 481.256 198.842 480.972 198.654 480.756Z",
    fill: "url(#paint79_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.144 505.674C194.799 505.275 194.344 504.989 193.838 504.852C193.332 504.716 192.798 504.734 192.302 504.905C191.807 505.077 191.373 505.394 191.054 505.816C190.736 506.237 190.549 506.746 190.515 507.276C190.482 507.806 190.604 508.334 190.866 508.794C191.129 509.253 191.52 509.624 191.989 509.858C192.459 510.092 192.987 510.18 193.506 510.11C194.025 510.04 194.512 509.815 194.905 509.464C195.432 508.994 195.753 508.33 195.798 507.619C195.843 506.909 195.608 506.209 195.144 505.674Z",
    fill: "url(#paint80_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M256.223 482.257C256.038 482.042 255.794 481.888 255.523 481.813C255.252 481.739 254.965 481.748 254.699 481.84C254.433 481.931 254.199 482.101 254.028 482.327C253.857 482.553 253.756 482.825 253.737 483.11C253.719 483.394 253.784 483.678 253.925 483.925C254.066 484.172 254.275 484.37 254.528 484.496C254.78 484.622 255.063 484.669 255.341 484.631C255.62 484.593 255.881 484.473 256.092 484.284C256.372 484.032 256.544 483.677 256.568 483.298C256.592 482.918 256.468 482.544 256.223 482.257Z",
    fill: "url(#paint81_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M266.968 494.64C266.911 494.573 266.836 494.526 266.753 494.502C266.67 494.479 266.582 494.482 266.5 494.51C266.418 494.538 266.346 494.59 266.293 494.659C266.241 494.729 266.21 494.813 266.204 494.9C266.198 494.988 266.219 495.075 266.262 495.151C266.306 495.226 266.37 495.287 266.448 495.326C266.526 495.364 266.613 495.378 266.698 495.366C266.784 495.354 266.864 495.316 266.929 495.258C267.014 495.181 267.066 495.073 267.073 494.957C267.08 494.841 267.042 494.727 266.968 494.64Z",
    fill: "url(#paint82_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M261.446 498.451C261.39 498.384 261.316 498.336 261.232 498.312C261.149 498.289 261.06 498.291 260.978 498.318C260.896 498.346 260.823 498.398 260.77 498.468C260.717 498.537 260.686 498.621 260.681 498.709C260.675 498.797 260.695 498.884 260.739 498.96C260.783 499.036 260.848 499.097 260.926 499.135C261.004 499.174 261.091 499.187 261.177 499.175C261.263 499.162 261.343 499.124 261.407 499.065C261.491 498.988 261.542 498.881 261.549 498.766C261.557 498.652 261.52 498.539 261.446 498.451Z",
    fill: "url(#paint83_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M245.639 493.623C245.299 493.228 244.851 492.944 244.351 492.808C243.851 492.671 243.323 492.689 242.833 492.857C242.343 493.026 241.914 493.339 241.599 493.755C241.285 494.172 241.099 494.674 241.066 495.198C241.033 495.722 241.154 496.244 241.414 496.698C241.673 497.152 242.06 497.517 242.525 497.748C242.99 497.979 243.511 498.064 244.024 497.994C244.537 497.923 245.017 497.699 245.404 497.351C245.921 496.887 246.235 496.235 246.279 495.536C246.323 494.838 246.093 494.15 245.639 493.623Z",
    fill: "url(#paint84_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M266.37 505.785C266.17 505.555 265.908 505.391 265.617 505.313C265.326 505.234 265.018 505.246 264.733 505.345C264.448 505.444 264.198 505.626 264.015 505.87C263.833 506.113 263.725 506.405 263.706 506.711C263.687 507.016 263.758 507.32 263.909 507.584C264.061 507.849 264.286 508.061 264.557 508.196C264.827 508.33 265.131 508.38 265.43 508.34C265.729 508.299 266.009 508.169 266.235 507.967C266.385 507.833 266.508 507.67 266.597 507.488C266.685 507.305 266.737 507.107 266.749 506.904C266.762 506.701 266.735 506.498 266.67 506.306C266.604 506.114 266.503 505.937 266.37 505.785Z",
    fill: "url(#paint85_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M255.683 485.393C255.542 485.232 255.357 485.116 255.152 485.061C254.946 485.006 254.729 485.013 254.528 485.083C254.327 485.153 254.151 485.282 254.022 485.454C253.893 485.625 253.817 485.832 253.804 486.047C253.791 486.262 253.84 486.477 253.947 486.663C254.054 486.85 254.212 487 254.403 487.095C254.594 487.19 254.808 487.226 255.019 487.197C255.23 487.169 255.428 487.077 255.587 486.935C255.801 486.743 255.93 486.473 255.948 486.184C255.966 485.895 255.871 485.611 255.683 485.393Z",
    fill: "url(#paint86_linear_305_41704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.173 510.312C251.827 509.913 251.372 509.627 250.867 509.49C250.361 509.354 249.826 509.372 249.331 509.544C248.835 509.715 248.401 510.032 248.083 510.454C247.765 510.876 247.577 511.384 247.544 511.914C247.51 512.444 247.632 512.972 247.895 513.432C248.157 513.892 248.548 514.262 249.018 514.496C249.488 514.73 250.015 514.818 250.534 514.748C251.053 514.678 251.54 514.453 251.933 514.102C252.46 513.632 252.782 512.968 252.826 512.258C252.871 511.547 252.636 510.847 252.173 510.312Z",
    fill: "url(#paint87_linear_305_41704)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_305_41704",
    x1: 212.976,
    y1: 451.291,
    x2: 220.351,
    y2: 451.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_305_41704",
    x1: 225.927,
    y1: 454.83,
    x2: 230.328,
    y2: 454.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_305_41704",
    x1: 221.717,
    y1: 458.752,
    x2: 224.551,
    y2: 458.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_305_41704",
    x1: 253.397,
    y1: 450.183,
    x2: 256.232,
    y2: 450.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_305_41704",
    x1: 213.959,
    y1: 468.479,
    x2: 214.816,
    y2: 468.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_305_41704",
    x1: 231.831,
    y1: 466.435,
    x2: 232.688,
    y2: 466.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_305_41704",
    x1: 265.87,
    y1: 461.906,
    x2: 266.732,
    y2: 461.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_305_41704",
    x1: 260.355,
    y1: 465.714,
    x2: 261.213,
    y2: 465.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_305_41704",
    x1: 225.418,
    y1: 482.951,
    x2: 235.884,
    y2: 482.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_305_41704",
    x1: 240.741,
    y1: 462.343,
    x2: 245.943,
    y2: 462.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_305_41704",
    x1: 197.204,
    y1: 480.128,
    x2: 202.411,
    y2: 480.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_305_41704",
    x1: 225.809,
    y1: 423.744,
    x2: 231.012,
    y2: 423.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_305_41704",
    x1: 179.664,
    y1: 441.352,
    x2: 184.866,
    y2: 441.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_305_41704",
    x1: 187.992,
    y1: 405.841,
    x2: 190.5,
    y2: 405.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_305_41704",
    x1: 263.363,
    y1: 473.78,
    x2: 266.41,
    y2: 473.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_305_41704",
    x1: 220.072,
    y1: 475.38,
    x2: 223.119,
    y2: 475.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_305_41704",
    x1: 248.069,
    y1: 484.722,
    x2: 250.219,
    y2: 484.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_305_41704",
    x1: 253.457,
    y1: 453.094,
    x2: 255.608,
    y2: 453.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_305_41704",
    x1: 247.198,
    y1: 479.063,
    x2: 252.492,
    y2: 479.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_305_41704",
    x1: 208.404,
    y1: 403.433,
    x2: 215.778,
    y2: 403.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_305_41704",
    x1: 221.356,
    y1: 406.972,
    x2: 225.758,
    y2: 406.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_305_41704",
    x1: 217.147,
    y1: 410.891,
    x2: 219.981,
    y2: 410.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_305_41704",
    x1: 248.826,
    y1: 402.321,
    x2: 251.66,
    y2: 402.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_305_41704",
    x1: 209.389,
    y1: 420.617,
    x2: 210.247,
    y2: 420.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_305_41704",
    x1: 227.258,
    y1: 418.571,
    x2: 228.115,
    y2: 418.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_305_41704",
    x1: 261.3,
    y1: 414.043,
    x2: 262.162,
    y2: 414.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_305_41704",
    x1: 255.784,
    y1: 417.856,
    x2: 256.641,
    y2: 417.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_305_41704",
    x1: 220.847,
    y1: 435.088,
    x2: 231.313,
    y2: 435.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_305_41704",
    x1: 236.171,
    y1: 414.486,
    x2: 241.373,
    y2: 414.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_305_41704",
    x1: 192.631,
    y1: 432.266,
    x2: 197.838,
    y2: 432.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_305_41704",
    x1: 221.238,
    y1: 375.886,
    x2: 226.441,
    y2: 375.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_305_41704",
    x1: 175.092,
    y1: 393.494,
    x2: 180.294,
    y2: 393.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_305_41704",
    x1: 183.42,
    y1: 357.982,
    x2: 185.927,
    y2: 357.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_305_41704",
    x1: 258.792,
    y1: 425.923,
    x2: 261.839,
    y2: 425.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_305_41704",
    x1: 215.501,
    y1: 427.517,
    x2: 218.548,
    y2: 427.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_305_41704",
    x1: 243.498,
    y1: 436.859,
    x2: 245.649,
    y2: 436.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_305_41704",
    x1: 248.887,
    y1: 405.231,
    x2: 251.038,
    y2: 405.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_305_41704",
    x1: 242.626,
    y1: 431.205,
    x2: 247.919,
    y2: 431.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_305_41704",
    x1: 214.331,
    y1: 351.029,
    x2: 221.705,
    y2: 351.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_305_41704",
    x1: 227.28,
    y1: 354.568,
    x2: 231.686,
    y2: 354.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_305_41704",
    x1: 223.071,
    y1: 358.485,
    x2: 225.905,
    y2: 358.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_305_41704",
    x1: 254.752,
    y1: 349.921,
    x2: 257.586,
    y2: 349.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_305_41704",
    x1: 215.312,
    y1: 368.214,
    x2: 216.174,
    y2: 368.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_305_41704",
    x1: 233.185,
    y1: 366.173,
    x2: 234.042,
    y2: 366.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_305_41704",
    x1: 267.223,
    y1: 361.64,
    x2: 268.085,
    y2: 361.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_305_41704",
    x1: 261.709,
    y1: 365.453,
    x2: 262.567,
    y2: 365.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_305_41704",
    x1: 226.776,
    y1: 382.689,
    x2: 237.242,
    y2: 382.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_305_41704",
    x1: 242.097,
    y1: 362.082,
    x2: 247.303,
    y2: 362.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_305_41704",
    x1: 198.561,
    y1: 379.866,
    x2: 203.764,
    y2: 379.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_305_41704",
    x1: 227.163,
    y1: 323.483,
    x2: 232.37,
    y2: 323.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_305_41704",
    x1: 181.016,
    y1: 341.091,
    x2: 186.222,
    y2: 341.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_305_41704",
    x1: 189.344,
    y1: 305.579,
    x2: 191.852,
    y2: 305.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_305_41704",
    x1: 264.717,
    y1: 373.518,
    x2: 267.764,
    y2: 373.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_305_41704",
    x1: 221.425,
    y1: 375.114,
    x2: 224.476,
    y2: 375.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_305_41704",
    x1: 249.426,
    y1: 384.46,
    x2: 251.577,
    y2: 384.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_305_41704",
    x1: 254.813,
    y1: 352.828,
    x2: 256.964,
    y2: 352.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_305_41704",
    x1: 248.552,
    y1: 378.803,
    x2: 253.846,
    y2: 378.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_305_41704",
    x1: 195.618,
    y1: 302.637,
    x2: 202.997,
    y2: 302.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_305_41704",
    x1: 208.569,
    y1: 306.175,
    x2: 212.975,
    y2: 306.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_305_41704",
    x1: 204.359,
    y1: 310.094,
    x2: 207.193,
    y2: 310.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_305_41704",
    x1: 196.712,
    y1: 478.569,
    x2: 199.546,
    y2: 478.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_305_41704",
    x1: 196.602,
    y1: 319.821,
    x2: 197.464,
    y2: 319.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_305_41704",
    x1: 214.474,
    y1: 317.776,
    x2: 215.336,
    y2: 317.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_305_41704",
    x1: 209.184,
    y1: 490.288,
    x2: 210.042,
    y2: 490.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_305_41704",
    x1: 203.663,
    y1: 494.1,
    x2: 204.525,
    y2: 494.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_305_41704",
    x1: 208.065,
    y1: 334.292,
    x2: 218.531,
    y2: 334.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_305_41704",
    x1: 184.053,
    y1: 490.73,
    x2: 189.26,
    y2: 490.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_305_41704",
    x1: 194.862,
    y1: 337.512,
    x2: 200.068,
    y2: 337.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_305_41704",
    x1: 206.672,
    y1: 502.166,
    x2: 209.723,
    y2: 502.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_305_41704",
    x1: 202.714,
    y1: 326.722,
    x2: 205.765,
    y2: 326.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_305_41704",
    x1: 242.77,
    y1: 308.477,
    x2: 250.145,
    y2: 308.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_305_41704",
    x1: 255.723,
    y1: 312.015,
    x2: 260.128,
    y2: 312.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_305_41704",
    x1: 251.513,
    y1: 315.934,
    x2: 254.348,
    y2: 315.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_305_41704",
    x1: 243.756,
    y1: 325.661,
    x2: 244.618,
    y2: 325.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_305_41704",
    x1: 261.625,
    y1: 323.615,
    x2: 262.483,
    y2: 323.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_305_41704",
    x1: 255.218,
    y1: 340.133,
    x2: 265.684,
    y2: 340.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_305_41704",
    x1: 242.013,
    y1: 343.353,
    x2: 247.219,
    y2: 343.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_305_41704",
    x1: 249.866,
    y1: 332.56,
    x2: 252.918,
    y2: 332.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_305_41704",
    x1: 191.381,
    y1: 513.105,
    x2: 193.532,
    y2: 513.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_305_41704",
    x1: 196.769,
    y1: 481.476,
    x2: 198.919,
    y2: 481.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_305_41704",
    x1: 190.512,
    y1: 507.45,
    x2: 195.806,
    y2: 507.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_305_41704",
    x1: 253.741,
    y1: 483.206,
    x2: 256.575,
    y2: 483.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_305_41704",
    x1: 266.215,
    y1: 494.927,
    x2: 267.072,
    y2: 494.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_305_41704",
    x1: 260.693,
    y1: 498.738,
    x2: 261.555,
    y2: 498.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_305_41704",
    x1: 241.081,
    y1: 495.368,
    x2: 246.288,
    y2: 495.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_305_41704",
    x1: 263.701,
    y1: 506.805,
    x2: 266.753,
    y2: 506.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_305_41704",
    x1: 253.798,
    y1: 486.113,
    x2: 255.949,
    y2: 486.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_305_41704",
    x1: 247.536,
    y1: 512.088,
    x2: 252.834,
    y2: 512.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_41704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 428,
    height: 639,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_305_41704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 674.832,
    height: 503,
    fill: "white",
    transform: "translate(-135 136)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubblesMobile);
export default __webpack_public_path__ + "static/media/bubbles-mobile.c6681a21e92f6de0ae214a3dcb8a5b3f.svg";
export { ForwardRef as ReactComponent };